import {
  getPatternDefForPage,
  getCollection,
} from '@wix/wix-data-client-common'
import type { PageRef, RouterRef } from '@wix/editor-platform-sdk-types'
import type {
  EditorSDK,
  RouterConfig,
} from '@wix/wix-data-client-common-standalone'

type GetDPCollectionName = ({
  editorSdkProxy,
  routerRef,
  pageRef,
}: {
  editorSdkProxy: EditorSDK
  routerRef: RouterRef
  pageRef: PageRef
}) => Promise<string | undefined>

export const getDPCollectionName: GetDPCollectionName = async ({
  editorSdkProxy,
  routerRef,
  pageRef,
}) => {
  if (!routerRef) {
    return
  }

  const router = await editorSdkProxy.routers.get<RouterConfig>({ routerRef })
  const patternDef = getPatternDefForPage(router.config, router.pages, pageRef)
  const collectionName = patternDef.def
    ? getCollection(patternDef.def)
    : undefined
  return collectionName
}
